import _extends from "@babel/runtime/helpers/extends";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const optionShape = {
  /**
   * The radio button's ID
   */
  id: PropTypes.string.isRequired,
  /**
   * Text that appears in the radio button
   */
  label: PropTypes.string.isRequired,
  /**
   * The value returned by the radio button
   */
  value: PropTypes.string.isRequired
};
const propTypes = {
  /**
   * The form's legend
   */
  legend: PropTypes.string.isRequired,
  /**
   * the html name attribute for the radio pill group
   */
  groupName: PropTypes.string.isRequired,
  /**
   * accessibly hide the legend
   */
  hideLegend: PropTypes.bool,
  /**
   * Which radio button is selected on load
   */
  currentValue: PropTypes.string.isRequired,
  /**
   * An array of Options objects
   */
  options: PropTypes.arrayOf(PropTypes.shape(optionShape)).isRequired,
  /**
   * Is the form disabled
   */
  fieldDisabled: PropTypes.bool,
  /**
   * Is the form required
   */
  fieldRequired: PropTypes.bool,
  /**
   * Use the small version of the form
   */
  fieldSmall: PropTypes.bool,
  /**
   * Function that runs when a radio button is clicked
   */
  handleRadioPillChange: PropTypes.func
};
const defaultProps = {
  fieldDisabled: false,
  fieldRequired: true,
  fieldSmall: false,
  hideLegend: false,
  handleRadioPillChange: () => {}
};
class RadioPill extends Component {
  constructor(props) {
    super(props);
    this.handleOnChange = event => {
      this.props.handleRadioPillChange(event);
      if (event.target.id !== this.state.currentValue) {
        this.setState({
          currentValue: event.target.id
        });
      }
    };
    const firstValue = props.options.filter(option => option.id === props.currentValue)[0].id;
    if (firstValue) {
      this.state = {
        currentValue: firstValue,
        lastProp: firstValue
      };
    } else {
      throw Error('prop intialValue must match one of the option Ids');
    }
  }
  static getDerivedStateFromProps(props, state) {
    // lastProp tracks changes to props and updates
    // if new props have been provided
    if (state.lastProp !== props.currentValue) {
      return {
        currentValue: props.currentValue,
        lastProp: props.currentValue
      };
    } else {
      return null;
    }
  }
  render() {
    const {
      options,
      legend,
      groupName,
      hideLegend,
      fieldRequired,
      fieldSmall,
      fieldDisabled
    } = this.props;
    return /*#__PURE__*/React.createElement("fieldset", {
      className: classNames('asc-form-group', 'asc-form-group--radio', {
        'is-disabled': fieldDisabled
      })
    }, /*#__PURE__*/React.createElement("legend", {
      className: classNames('asc-form-label', {
        'asc-acc-hidden': hideLegend
      })
    }, /*#__PURE__*/React.createElement("span", {
      className: fieldRequired ? 'is-required' : ''
    }, legend)), /*#__PURE__*/React.createElement("div", {
      className: classNames('asc-radio-group', 'asc-radio-group--pills', {
        'asc-radio-group--small-pills': fieldSmall
      })
    }, options.map(option => {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: option.id
      }, /*#__PURE__*/React.createElement("input", _extends({
        type: "radio"
      }, option, {
        name: groupName,
        disabled: fieldDisabled ? 'disabled' : '',
        checked: option.id === this.state.currentValue,
        onChange: this.handleOnChange
      })), /*#__PURE__*/React.createElement("label", {
        htmlFor: option.id
      }, option.label));
    })));
  }
}
RadioPill.defaultProps = defaultProps;
RadioPill.propTypes = propTypes;
export default RadioPill;